import { emptyValidator, formValidator, numberOnlyValidator, bankNameValidator } from "../../validators";

const bankValidationStatus = {
  bnkName: {
    validators: [emptyValidator(), bankNameValidator()],
    name: "Bank Name",
  },
  bnkCompany: {
    validators: [],
    name: "Company",
  },
  bnkStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  bnkActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
};

export const bankValidation = (bank) => {
  return formValidator(bank, bankValidationStatus);
};
